var _defs, _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientsSelected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.615,15.249l-3.676-1.838C16.832,11.624,16.993,8.181,17,8.02V8l-.007-3.082C16.62,2.675,14.051,1,12,1h0a4.971,4.971,0,0,0-2,.479h0A5.014,5.014,0,0,0,8,1H8C5.95,1,3.379,2.676,3,5V8.02c.007.157.161,3.544,2.075,5.383l-3.69,1.846A2.489,2.489,0,0,0,0,17.489V18a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1v-.511A2.489,2.489,0,0,0,18.615,15.249ZM19,18H5v-.511a1.494,1.494,0,0,1,.832-1.346l4.392-2.2a.5.5,0,0,0,.045-.868C8.176,11.744,8,8.018,8,8L7.993,5.082A4.3,4.3,0,0,1,12,2a4.312,4.312,0,0,1,4,3V7.988c-.011.2-.23,3.873-2.256,5.083a.5.5,0,0,0,.032.876l4.392,2.2A1.494,1.494,0,0,1,19,17.489Z",
    transform: "translate(0 -0.001)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsSelected);
export default __webpack_public_path__ + "static/media/ClientsSelected.d518a70846d484bdaf7fbd8ba557f6a4.svg";
export { ForwardRef as ReactComponent };